var map = {
	"./de/gotoTOPbg.png": "DhVk",
	"./en/gotoTOPbg.png": "4F6m",
	"./es/gotoTOPbg.png": "fHRK",
	"./fr/gotoTOPbg.png": "V36M",
	"./ja/gotoTOPbg.png": "mwq6",
	"./ko/gotoTOPbg.png": "hClg",
	"./pt/gotoTOPbg.png": "/FZC",
	"./ru/gotoTOPbg.png": "0vsd",
	"./tc/gotoTOPbg.png": "kk7w",
	"./th/gotoTOPbg.png": "uetq"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yxhl";